import { render, staticRenderFns } from "./RolesStepperPermissions.vue?vue&type=template&id=ceaa6646&scoped=true"
import script from "./RolesStepperPermissions.vue?vue&type=script&lang=js"
export * from "./RolesStepperPermissions.vue?vue&type=script&lang=js"
import style0 from "./RolesStepperPermissions.vue?vue&type=style&index=0&id=ceaa6646&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaa6646",
  null
  
)

export default component.exports